import { Layout } from './layout.interface';
import { Partner } from './partner.interface';
import { PrintableReport } from './printable-reports.interface';
import { Widget } from './widget.interface';

/**
 *
 */
export interface Configuration {
	directoryName: any;
	useDefaultConfig?: boolean;
	partner: Partner;
	version: string;
	useDefaultHtmls: boolean;
	dataSources: DataSource[];
	layout?: Layout;
	styles?: string[];
	routing?: Routing;
	navWidgets: Widget[];
	widgets: Widget[];
	overviewWidgets: Widget[];
	products: Product[];
	maps: Widget[];
	isNavigationCarousel: any;
	enableDatePickerInputBox: boolean;
	downloadIcon: string;
	handleLockIcon: string;
	closeHandleIcon: string;
	openHandleIcon: string;
	disclaimer: string;
	maxAdvertisersAllowed: number;
	overviewPrintableReport: PrintableReport;
}

export interface Product {
	uniqueOverwriteID: string;
	productCsvFilename: any;
	enableProductDownloadConfig: boolean;
	printableStrategyName: any;
	productName: string;
	productURL: string;
	isCarousel: any;
	widgets: Widget[];
	overviewWidgets: Widget[];
	printableReport: PrintableReport;
	isTab: boolean;
	enableLeftNavWidgets: boolean;
	printableModalPopUp: boolean;
}

export interface Routing {
	defaultRoute: string;
}

export interface DataSource {
	name: string;
	id: string;
	selected: boolean;
}

export interface NavigateProcessRequestStatus {
	[key: string]: NAVIGATION_REQUEST_STATUSES;
}

export enum NAVIGATION_REQUEST_STATUSES {
	IN_PROGRESS,
	COMPLETED
}
